export const en = {
  nav: {
    pillars: "Activities", network: "Network", wrd: "World Rhubarb Day", knowledge: "Knowledge",
    transparency: "Transparency", join: "Join the Association", brandTop: "World Rhubarb", brandBottom: "Association",
  },
  footer: {
    tagline: "The global network connecting the people and organizations working to grow the rhubarb industry.",
    ledger: ["Status: Foundation stage", "Founded: 2026", "Founder / Representative: Kohei Sudo", "Core team: 2 · External members: 0", "Legal entity: Voluntary initiative"],
    orgTitle: "Organization",
    orgLinks: ["Vision & Mission", "Roadmap", "Transparency", "Contact"],
    initTitle: "Initiatives",
    initLinks: ["World Rhubarb Day", "Market Expansion", "Knowledge Hub", "Global Database"],
    refTitle: "Reference Models",
    copyright: "© 2026 World Rhubarb Association",
    verified: "Verified data only · No invented figures",
  },
  hero: {
    kicker: "World Rhubarb Association — Est. 2026",
    h1a: "Connecting the World", h1bPre: "", h1b: "Through", h1c: "Rhubarb.",
    para: "We connect rhubarb growers, researchers, businesses and enthusiasts around the world — to grow the rhubarb industry and build its sustainable future.",
    ctaJoin: "Join the Association", ctaActivities: "Our Activities",
    stats: [["Founded", "2026"], ["Core team", "2"]],
    statMembers: "Registered members", statCountries: "Countries",
    statsNote: "Accurate at launch · Updated as the network grows",
    specimen: "Specimen · Rhubarb field, open cultivation",
  },
  marquee: ["Rheum rhabarbarum", "Established 2026", "Building the Founding Network", "Zero hyperbole", "Growers · Researchers · Chefs", "World Rhubarb Day Initiative", "Verified data only"],
  pillars: {
    kicker: "Our Activities",
    title: "Six activities, pursued in the open.",
    items: [
      { title: "Connect Producers", text: "We connect rhubarb growers around the world, encouraging the exchange of knowledge, cooperation and the opening of new sales channels.", tags: ["Knowledge exchange", "Cooperation", "New sales channels"] },
      { title: "Expand the Market", text: "We develop new uses, products and markets for rhubarb, growing demand worldwide.", tags: ["New uses", "Product development", "Global demand"] },
      { title: "Support New Producers", text: "We help new growers start cultivating — with cultivation know-how, proven examples and market information.", tags: ["Cultivation know-how", "Proven examples", "Market information"] },
      { title: "Research & Data", text: "We collect information on global rhubarb production, distribution, varieties and markets — and build it into a database.", tags: ["Production", "Varieties", "Market data"] },
      { title: "International Collaboration", text: "We build international partnerships with organizations, universities, researchers, businesses and public bodies across countries.", tags: ["Organizations", "Universities", "Public bodies"] },
      { title: "World Rhubarb Day", text: "We work to establish and spread World Rhubarb Day, raising awareness of rhubarb worldwide.", tags: ["Awareness", "Establishment", "Global celebration"] },
    ],
  },
  network: {
    kicker: "Our Global Network",
    titleA: "We are building our ", titleAccent: "founding network.",
    para: "Right now the network is a two-person founding team. Everyone who joins from here will be a real person or organization that formally agreed to take part — and no name is ever listed without consent.",
    stages: [
      { stage: "Founding Team", note: "2026 · 2 people · Active now", state: "active" },
      { stage: "Founding Network", note: "Building — applications open", state: "building" },
      { stage: "International Network", note: "Members across countries", state: "future" },
      { stage: "Global Industry Platform", note: "The long-term destination", state: "future" },
    ],
    stateLabels: { active: "Now", building: "Building", future: "Future" },
    mapKicker: "Global Network Map",
    globeNote: "Nodes mark open regions · Network status: founding phase",
    chapterNote: "National Chapter — Not yet established",
    regionStatus: "Country Representative — Open",
    regions: ["East & Southeast Asia", "Europe", "North America", "South America", "Africa", "Oceania"],
    regionsNote: "Countries represented: 0. Chapters appear here only after formal appointment — never before.",
  },
  manifesto: {
    kicker: "Why We Exist — A Manifesto in Three Chapters",
    chapters: [
      { title: "The Overlooked Perennial", text: "From Yorkshire forcing sheds to the fields of Hokkaido, rhubarb has fed people for centuries — yet it has no global voice, no shared data, no unified industry. The value is real. It is simply scattered." },
      { title: "A Fragmented Industry", text: "Growers, scientists, chefs and food companies each work alone. Knowledge sits locked inside separate institutions. Market information is scattered — or missing entirely. Nobody connects the pieces." },
      { title: "From Two People to a Platform", text: "WRA starts where it honestly is: a two-person founding team in 2026, zero external members, zero partners. Our strategy is not to pretend at scale but to earn it — two people, then a founding network, then an international network, then a global platform for the rhubarb industry." },
    ],
  },
  mission: {
    kicker: "Vision & Mission", visionLabel: "Vision", missionLabel: "Mission",
    vision: "A world where rhubarb's economic and cultural value is fully realized — and where everyone who grows, studies, cooks and sells it is connected.",
    items: [
      "Grow the global rhubarb market — and secure the growers behind it — through awareness, product development and shared market intelligence.",
      "Build an international network of growers, researchers, businesses and enthusiasts.",
      "Work toward establishing World Rhubarb Day as an internationally recognized celebration.",
    ],
  },
  who: {
    kicker: "Who Can Join",
    title: "Seven kinds of people grow an industry.",
    items: [
      { title: "Growers", text: "Rhubarb producers in every country — field and forced, commercial and small-scale, established and just starting out." },
      { title: "Researchers", text: "Universities and institutes in plant science, agronomy and food science." },
      { title: "Food Businesses", text: "Manufacturers, processors and product development companies." },
      { title: "Chefs", text: "Restaurants and culinary professionals shaping rhubarb gastronomy." },
      { title: "Retailers", text: "Retail, distribution and import/export businesses." },
      { title: "Agricultural Organizations", text: "Grower associations, regional bodies and producer cooperatives." },
      { title: "Enthusiasts", text: "Home growers, cooks and everyone who simply loves rhubarb." },
    ],
    ctaCard: "Whichever you are — the network starts with you.",
    cta: "Join the Network",
  },
  membership: {
    kicker: "Membership",
    titleA: "Founding Network — ", titleAccent: "currently being established.",
    para: "External members today: zero. Instead of inventing a roster, we publish the rules first. A formal membership policy is in preparation and will appear on the Transparency page before the first member is ever listed.",
    principles: [
      { t: "Consent-first listing", d: "Names, countries and roles are published only with formal written agreement." },
      { t: "Governance in preparation", d: "Advisory board, committees and country representatives are planned structures — not filled seats." },
      { t: "Open categories", d: "Growers, researchers, businesses, chefs, retailers, agricultural organizations, enthusiasts." },
    ],
    specimen: "Specimen · Freshly bundled stalks, grower market",
  },
  whyJoin: {
    kicker: "Why Join the Founding Network?",
    title: "Six reasons to join early.",
    items: [
      { title: "International connections", text: "Connect with rhubarb growers, researchers, businesses and organizations around the world." },
      { title: "Founding Member recognition", text: "Be recognized as a Founding Member during the founding phase." },
      { title: "Directory visibility", text: "Optional visibility in the Global Member Directory — only if you choose it." },
      { title: "Knowledge exchange", text: "International exchange of cultivation, market and research knowledge." },
      { title: "International meetings", text: "Opportunities to take part in future online international meetings." },
      { title: "Collaboration opportunities", text: "Potential opportunities for research, business and other collaborations." },
    ],
    note: "Membership is free during the founding phase and open worldwide. These benefits describe opportunities — nothing is guaranteed.",
    cta: "Join the Founding Network",
  },
  market: {
    kicker: "Pillar I — Market Expansion",
    titleA: "Expanding the market, ", titleAccent: "concretely.",
    items: [
      { title: "Consumer Awareness", text: "What rhubarb is, world rhubarb cuisines, history, varieties, cultivation, seasonality and recipes — published for a global audience.", alt: "Rhubarb stalks arranged showing carmine gradients" },
      { title: "Product Development", text: "Jams, sauces, beverages, desserts, bakery, fermented products, seasonings, confectionery and non-food applications. No unverified health claims — ever.", alt: "Freshly bundled rhubarb stalks" },
      { title: "Growers & Grower–Business Matching", text: "Helping regions secure and keep rhubarb growers — and connecting them through a future Grower Directory and Business Directory: producers supply raw material, companies develop products, restaurants build menus.", alt: "Open rhubarb field cultivation" },
      { title: "Market Data", text: "A Global Rhubarb Market Database — production, varieties, seasons, trade. Where data does not exist, we say so: Data unavailable.", alt: "Agricultural research specimens" },
    ],
  },
  international: {
    kicker: "Pillar II — International Network",
    title: "How a network gets built — in order.",
    items: [
      { t: "Founding Network", d: "Building now. Formal participation by invitation and application — only confirmed participants are listed." },
      { t: "International Outreach", d: "An open call to growers, associations, universities, researchers, food companies, chefs and retailers worldwide — including helping new regions secure their first rhubarb growers." },
      { t: "Country Representatives", d: "Introduced once a country reaches a critical mass of members. Listed only upon formal appointment." },
      { t: "National Chapters", d: "Future structures such as WRA Japan, WRA UK, WRA Poland — established with a clear, public relationship to WRA." },
      { t: "International Meetings", d: "Online meetings, webinars, research seminars, grower meetings and, in time, international conferences." },
    ],
  },
  wrd: {
    kicker: "Pillar III — World Rhubarb Day",
    badge: "Initiative · Proposed — not yet official",
    titleA: "A global celebration of rhubarb — ", titleAccent: "to be earned, not declared.",
    para: "We aim to establish World Rhubarb Day as an internationally recognized celebration of rhubarb, its growers, its culture and its future. The process is public: research, proposal, endorsements, national organizers, then a global campaign.",
    cta1: "Explore the Initiative", cta2: "Support World Rhubarb Day",
    phases: [
      { p: "Phase 1", t: "Research & Proposal", d: "Global consultation on history, culture, seasons and a suitable date." },
      { p: "Phase 2", t: "International Support", d: "Endorsements from growers, universities, organizations and chefs — published with consent." },
      { p: "Phase 3", t: "Country Organizers", d: "National representatives and chapters drive the day locally." },
      { p: "Phase 4", t: "Global Campaign", d: "Events, fairs, contests and education — coordinated worldwide." },
    ],
  },
  knowledge: {
    kicker: "Rhubarb Knowledge Hub",
    titleA: "Knowledge worth ", titleAccent: "citing.",
    para: "An evidence-based library in preparation. Articles will cite university research, government sources, agricultural organizations and peer-reviewed papers wherever possible.",
    statusLabel: "Library status",
    statusText: "Collection begins 2026 — articles published progressively, each with named sources.",
    categories: ["Cultivation", "Varieties", "Plant Science", "Food Science", "Processing", "Sustainability", "Economics", "History", "Culture"],
    catNote: "In preparation",
  },
  database: {
    kicker: "Global Rhubarb Database",
    titleA: "Empty today. ", titleAccent: "Honest always.",
    para: "WRA's long-term data asset: verified records of the world's rhubarb industry. No invented figures — where no verified data exists, a field simply reads \"Data unavailable.\"",
    badge: "Data unavailable",
    items: [
      { name: "Countries", desc: "Rhubarb profiles per country" },
      { name: "Growers", desc: "Producer registry" },
      { name: "Varieties", desc: "Cultivar records" },
      { name: "Researchers", desc: "Academic network" },
      { name: "Businesses", desc: "Food & processing companies" },
      { name: "Organizations", desc: "Related bodies" },
      { name: "Events", desc: "Rhubarb events worldwide" },
      { name: "Research", desc: "Studies & sources" },
    ],
  },
  roadmap: {
    kicker: "Our Roadmap", title: "2026 → 2030",
    disclaimer: "Long-term vision — not a fixed schedule", now: "Now",
    items: [
      { year: "2026", title: "Foundation", items: ["WRA launch", "Initial team formation", "International outreach begins"], active: true },
      { year: "2027", title: "Global Network", items: ["Founding members", "International growers & researchers", "Country representatives"] },
      { year: "2028", title: "Knowledge & Data", items: ["Global Rhubarb Database", "Rhubarb Knowledge Hub", "Research network"] },
      { year: "2029", title: "Market Development", items: ["Grower–business matching", "International product development", "Global market research"] },
      { year: "2030", title: "World Rhubarb Day", items: ["Global campaign", "International events", "Country-level celebrations"] },
    ],
  },
  join: {
    kicker: "Join the Movement",
    titleA: "Become a ", titleAccent: "Founding Network", titleB: " Member",
    para: "WRA launched in 2026 with a two-person founding team. Everything from here is built together with the people who join next. Register your interest and we will be in touch as the founding membership structure is formalized.",
    bullets: [
      "Only confirmed participants are ever listed — with their consent",
      "No membership fee has been set; the policy will be published first",
      "Growers, researchers, chefs, businesses and enthusiasts are all welcome",
    ],
    formTitle: "Founding Network — Expression of Interest",
    ph: { name: "Full name *", email: "Email *", country: "Country", org: "Organization (optional)", message: "Tell us how you'd like to contribute (optional)" },
    categoryPh: "I am a… *",
    categories: ["Grower", "Researcher / University", "Food Business", "Chef / Restaurant", "Retailer / Distributor", "Agricultural Organization", "Enthusiast", "Other"],
    submit: "Join the Network", submitting: "Submitting…",
    note: "Recorded as interest — formal membership opens with the published policy",
    thanks: "Thank you",
    success: "Thank you — we've sent a confirmation link to your email. Your registration completes when you click it.",
    toastOk: "Expression of interest recorded.",
    toastErr: "Submission failed. Please try again.",
  },
  wrdPage: {
    kicker: "World Rhubarb Day Initiative",
    badge: "Proposed · Campaign in formation",
    h1a: "World", h1b: "Rhubarb", h1c: "Day",
    sub: "A global celebration of rhubarb, its growers, its culture and its future.",
    para: "We aim to establish World Rhubarb Day as an internationally recognized celebration of rhubarb. It is not an official day yet — this page documents the open process of earning that recognition.",
    cta: "Support the Initiative",
    specimen: "Specimen · Rhubarb stalks, vivid carmine gradients",
    why: {
      kicker: "Why World Rhubarb Day?",
      items: [
        { title: "Cultural Heritage", text: "Rhubarb carries centuries of food culture — from English forcing sheds to Asian medicinal traditions to modern Nordic kitchens. It deserves a shared moment of recognition." },
        { title: "Grower Appreciation", text: "A day that puts producers first: the people who plant, force, harvest and bundle one of the world's most distinctive crops." },
        { title: "Seasonal Gastronomy", text: "A fixed point in the calendar for chefs, restaurants and food brands to celebrate rhubarb at its peak — in every hemisphere's season." },
        { title: "Agricultural Biodiversity", text: "Attention for the varieties, cultivation knowledge and research that keep rhubarb viable for the next century." },
      ],
    },
    proposal: {
      kicker: "Our Proposal",
      para: "The initiative moves through four working phases. Each phase produces a public artifact — research, a written proposal, a supporters' register and a campaign framework — published on this site as each is completed.",
      artifactLabel: "Current artifact",
      artifact: "World Rhubarb Day Proposal — in research, to be published openly.",
      phases: [
        { p: "Phase 1", t: "Research & Proposal", d: "Consult growers, organizations and researchers on rhubarb's history, culture, production regions, harvest seasons and a suitable date — then publish the World Rhubarb Day Proposal." },
        { p: "Phase 2", t: "International Support", d: "Invite endorsements from growers, universities, agricultural organizations, food companies, chefs and restaurants. Names published only with formal consent." },
        { p: "Phase 3", t: "National Chapters / Country Representatives", d: "Recruit country organizers — e.g. World Rhubarb Day – Japan, – United Kingdom, – Poland — with a clearly defined, public relationship to WRA." },
        { p: "Phase 4", t: "Global Campaign", d: "SNS campaigns, farm events, restaurant fairs, product campaigns, school and university programs, growing events, recipe and photo contests — worldwide." },
      ],
    },
    process: {
      kicker: "The Establishment Process — Made Transparent",
      title: "Seven steps. Each one publicly accounted for.",
      steps: [
        { t: "Global Consultation", d: "Hearings with growers, organizations and researchers worldwide: history, culture, production regions, harvest seasons, existing events.", status: "In preparation" },
        { t: "Date Selection", d: "Choosing a date that respects harvest seasons across hemispheres and existing national traditions.", status: "Upcoming" },
        { t: "Proposal Publication", d: "The World Rhubarb Day Proposal — published openly on this site for review.", status: "Upcoming" },
        { t: "International Endorsements", d: "Formal support from growers, universities, agricultural organizations, food companies and chefs.", status: "Upcoming" },
        { t: "Global Campaign", d: "Coordinated events: farm days, restaurant fairs, contests, school and university programs.", status: "Upcoming" },
        { t: "Official WRA Recognition", d: "Formal adoption by the WRA once its governance structure is established.", status: "Upcoming" },
        { t: "Broader International Recognition", d: "Working toward recognition by wider international and agricultural bodies.", status: "Upcoming" },
      ],
      active: "In preparation", upcoming: "Upcoming",
      footer: "Achievements at each step will be published here as they happen.",
    },
    organizer: {
      kicker: "Become a Country Organizer",
      titleA: "Carry the day into ", titleAccent: "your country.",
      para: "Country organizers lead World Rhubarb Day locally — events, partners and press. Organizer positions are open in every country, formally recognized by WRA, with the relationship made public.",
      examples: ["World Rhubarb Day – Japan", "World Rhubarb Day – United Kingdom", "World Rhubarb Day – Poland"],
      open: "Position open",
      cta: "Express interest",
      events: { label: "Events Around the World", title: "No official events yet.", text: "The first coordinated events are planned with the global campaign phase. Farm events, restaurant fairs, recipe contests and education programs will be listed here — only once confirmed." },
      supporters: { label: "Global Supporters", title: "Official supporters: 0.", text: "Supporter names, countries, organizations and positions appear here only after formal written consent. The register starts empty — and grows in the open." },
      resources: { label: "World Rhubarb Day Resources", title: "Organizer toolkit — in preparation.", text: "Visual identity, poster templates, event guides and press materials will be published here for country organizers." },
    },
    support: {
      kicker: "How to Support",
      titleA: "Lend the day your ", titleAccent: "name.",
      para: "Growers, universities, agricultural organizations, food companies, chefs and restaurants: pledge your support for establishing World Rhubarb Day. With your consent, your name joins the public register — and only ever with your consent.",
      formTitle: "Support World Rhubarb Day — Pledge",
      ph: { name: "Full name *", email: "Email *", country: "Country", org: "Organization", position: "Position / Role" },
      consent: "I consent to my name, country, organization and position being published as a supporter, once formally confirmed by WRA.",
      submit: "Support World Rhubarb Day", submitting: "Submitting…",
      thanks: "Thank you",
      successBase: "Your pledge of support for World Rhubarb Day has been recorded.",
      successConsent: " With your consent, your name may appear on the Global Supporters wall once endorsements are formally confirmed.",
      successNoConsent: " Your name will not be published.",
      toastOk: "Support pledge recorded.",
      toastErr: "Submission failed. Please try again.",
    },
  },
  transparency: {
    kicker: "Transparency & Governance",
    h1a: "Small today.", h1b: "Accountable always.",
    para: "WRA is a two-person initiative founded in 2026. We treat that smallness as a commitment: everything on this page — and this site — states the organization exactly as it is, and expands only as reality does.",
    org: {
      kicker: "Organization Information",
      facts: [
        ["Organization name", "World Rhubarb Association (WRA)"],
        ["Founder / Representative", "Kohei Sudo"],
        ["Core team", "2 people"],
        ["Founded", "2026"],
        ["Legal entity", "None — voluntary international initiative"],
        ["External members", "0 (founding network being established)"],
        ["Overseas members", "0"],
        ["Official partners", "0"],
      ],
    },
    gov: {
      kicker: "Governance",
      para: "The structure below is designed to grow — members, then representatives, then committees, then formal governance. Seats are shown exactly as they stand: filled, planned, or not yet established. No role is ever displayed with an invented name.",
      filled: "Filled", vacant: "Vacant",
      roles: [
        { role: "Founder / Executive Director", holder: "Kohei Sudo", filled: true },
        { role: "Advisory Board", holder: "Not yet established", filled: false },
        { role: "Board", holder: "Not yet established", filled: false },
        { role: "Research Committee", holder: "Planned", filled: false },
        { role: "Grower Committee", holder: "Planned", filled: false },
        { role: "World Rhubarb Day Committee", holder: "Planned", filled: false },
        { role: "Country Representatives", holder: "None appointed — positions open", filled: false },
      ],
    },
    docs: {
      kicker: "Documents & Publications",
      items: [
        { name: "Organization Information", status: "Published", note: "This page" },
        { name: "Leadership", status: "Published", note: "This page" },
        { name: "Membership Policy", status: "In preparation", note: "To be published before any member is listed" },
        { name: "Governance Charter", status: "In preparation", note: "Follows the founding network" },
        { name: "Code of Conduct", status: "In preparation", note: "Modelled on ISO / FAO / IAIA practice" },
        { name: "Annual Report FY2026", status: "To be published Q1 2027", note: "First full fiscal year" },
        { name: "Financial Information", status: "To be published", note: "With the first annual report" },
        { name: "World Rhubarb Day Proposal", status: "In research", note: "Published openly when complete" },
        { name: "Research Sources", status: "Ongoing", note: "Cited per article in the Knowledge Hub" },
      ],
    },
    manifesto: {
      kicker: "Zero-Exaggeration Manifesto",
      title: "Trust is the only growth strategy we have.",
      para: "A two-person organization cannot borrow credibility from invented scale. So WRA does the opposite: it publishes its exact size, and lets the accuracy of every page become its reputation.",
      principles: [
        "No invented members, countries, partners or endorsements — ever.",
        "Where data does not exist, the site says “Data unavailable.”",
        "Names are published only with formal, documented consent.",
        "World Rhubarb Day is presented as a proposal until it is formally established.",
        "Every number on this site can be traced to a real, current fact.",
      ],
    },
    models: {
      kicker: "Reference Models",
      para: "WRA's organizational design, transparency practice and knowledge publishing are modelled on established international institutions.",
      items: [
        { name: "ISO", desc: "Public member, committee and governance structures.", url: "https://www.iso.org/structure.html" },
        { name: "FAO", desc: "Open ethics, conduct and conflict-of-interest policies.", url: "https://www.fao.org/ethics/policies/en" },
        { name: "IAIA", desc: "Transparency through governance, financials and annual reports.", url: "https://iaia.org/transparency/" },
        { name: "Royal Horticultural Society", desc: "Systematic, source-backed horticultural knowledge.", url: "https://www.rhs.org.uk/vegetables/rhubarb/grow-your-own" },
      ],
      visit: "Visit reference",
    },
    contact: {
      kicker: "Formal Inquiries",
      para: "Membership questions, governance inquiries and press: please use the contact form on the main page. Every inquiry is answered by the founding team directly.",
      cta: "Contact WRA",
    },
  },
};
